<template>
  <div class='lightblue quotation-page'>
    <!-- 页面顶部 -->
    <topmenu ref="topmenu"></topmenu>
    <div class="quotation-content" ref="content">
      <div v-show="showTable">
        <h-table :loading="isLoading" :showTitle="true" class="black" :height="tableHeight" :columns="columnsBuy" :data="data" highlight-row
          row-select-only @on-row-click="clickEvent" :canDblclickTr="false" :immediateRowClick="true" ref="quote-list-1"></h-table>
        <footer-tabbar @itemClick="tabbarClick"></footer-tabbar>
      </div>
      <div class="trend-view" v-if="!showTable">
        <div class="back-btn" @click="back">
          <h-icon name="t-b-return" style="font-weight:900"></h-icon>
        </div>
        <div class="left-view">
          <chart-view ref="cartView" :show="showTable" :code="prodCode" :height="tableHeight" :goods="goodsInfo"></chart-view>
        </div>
        <div class="right-view">
          <div class="goods-style">
            <p style="color:#00FDFE;">{{this.tableCode}}</p>
            <p style="color:#DAC244;">{{this.tableName}}</p>
          </div>
          <five-grades ref="fiveGrade" :sharesPerHand="sharesPerHand" :gradesCount="gradesCount" :gradesData="gradesData">
            <goods-deal-detail ref="goodsDeal" :sharesPerHand="sharesPerHand" :preclosePx="rowData.preclosePx"></goods-deal-detail>
          </five-grades>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Topmenu } from '@frame/views/frame/index'
import ChartView from '@frame/views/quotation/chartView'
import FiveGrades from '@frame/views/quotation/fiveGrades'
import GoodsDealDetail from '@frame/views/quotation/goodsDealDetail'
import { getGoodsList } from '@frame/api/chart/chart'
import { getChildData } from '@common/entry/getChildData'
import { Chart } from 'hqchart'
import Socket from '@frame/utils/socket'
import unit from '@frame/utils/unit'
import '@frame/styles/main.scss'
import '@frame/my-theme-css/hui-otp-spot.css'
import FooterTabbar from './FooterTabbar'
import { setOptionalData, getOptionalData } from '@common/utils/tools'
var lastTimer, lastClick = null
export default {
  components: {
    ChartView,
    FiveGrades,
    GoodsDealDetail,
    Topmenu,
    FooterTabbar
  },
  data () {
    return {
      title: '',
      isLoading: false,
      tableHeight: 500,
      allList: [],
      optionalList: [],
      tabbarActive: 'all',
      columnsBuy: [
        {
          type: 'index',
          title: '序号',
          fixed: 'left',
          align: 'center',
          width: 40
        },
        {
          title: '代码',
          fixed: 'left',
          key: 'prodCode',
          width: 80
        },
        {
          title: '名称',
          fixed: 'left',
          key: 'prodName',
          width: 300,
          ellipsis: true
        },
        {
          title: '最新价',
          key: 'lastPx',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.lastPx, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'lastPx'))
          }
        },
        {
          title: '昨收价',
          key: 'preclosePx',
          width: 80,
          render: (h, p) => {
            return h('span', {class: 'preclosePx'}, this.format(p.row, 'preclosePx'))
          }
        },
        {
          title: '涨幅',
          key: 'pxChangeRate',
          width: 80,
          render: (h, p) => {
            let val = this.format(p.row, 'pxChangeRate')
            let cls = val !== '-' ? val > 0 ? 'PriceUp' : 'PriceDown' : ''
            return h('span', {class: cls}, val !== '-' ? val + '%' : val)
          }
        },
        {
          title: '涨跌',
          key: 'pxChange',
          width: 80,
          render: (h, p) => {
            let cls = p.row.pxChange > 0 ? 'PriceUp' : 'PriceDown'
            return h('span', {class: cls}, this.format(p.row, 'pxChange'))
          }
        },
        {
          title: '均价',
          key: 'avgPx',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.avgPx, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'avgPx'))
          }
        },
        {
          title: '最高价',
          key: 'highPx',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.highPx, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'highPx'))
          }
        },
        {
          title: '最低价',
          key: 'lowPx',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.lowPx, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'lowPx'))
          }
        },
        {
          title: '开盘价',
          key: 'openPx',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.openPx, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'openPx'))
          }
        },
        {
          title: '买一价',
          key: 'buyPrice1',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.buyPrice1, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'buyPrice1'))
          }
        },
        {
          title: '买二价',
          key: 'buyPrice2',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.buyPrice2, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'buyPrice2'))
          }
        },
        {
          title: '买三价',
          key: 'buyPrice3',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.buyPrice3, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'buyPrice3'))
          }
        },
        {
          title: '买四价',
          key: 'buyPrice4',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.buyPrice4, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'buyPrice4'))
          }
        },
        {
          title: '买五价',
          key: 'buyPrice5',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.buyPrice5, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'buyPrice5'))
          }
        },
        {
          title: '买一量',
          key: 'buyAmount1',
          width: 80,
          render: (h, p) => {
            return h('span', this.formatAmt(p.row, 'buyAmount1'))
          }
        },
        {
          title: '买二量',
          key: 'buyAmount2',
          width: 80,
          render: (h, p) => {
            return h('span', this.formatAmt(p.row, 'buyAmount2'))
          }
        },
        {
          title: '买三量',
          key: 'buyAmount3',
          width: 80,
          render: (h, p) => {
            return h('span', this.formatAmt(p.row, 'buyAmount3'))
          }
        },
        {
          title: '买四量',
          key: 'buyAmount4',
          width: 80,
          render: (h, p) => {
            return h('span', this.formatAmt(p.row, 'buyAmount4'))
          }
        },
        {
          title: '买五量',
          key: 'buyAmount5',
          width: 80,
          render: (h, p) => {
            return h('span', this.formatAmt(p.row, 'buyAmount5'))
          }
        },
        {
          title: '卖一价',
          key: 'sellPrice1',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.sellPrice1, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'sellPrice1'))
          }
        },
        {
          title: '卖二价',
          key: 'sellPrice2',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.sellPrice2, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'sellPrice2'))
          }
        },
        {
          title: '卖三价',
          key: 'sellPrice3',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.sellPrice3, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'sellPrice3'))
          }
        },
        {
          title: '卖四价',
          key: 'sellPrice4',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.sellPrice4, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'sellPrice4'))
          }
        },
        {
          title: '卖五价',
          key: 'sellPrice5',
          width: 80,
          render: (h, p) => {
            let cls = this.getColor(p.row.sellPrice5, p.row.preclosePx)
            return h('span', {class: cls}, this.format(p.row, 'sellPrice5'))
          }
        },
        {
          title: '卖一量',
          key: 'sellAmount1',
          width: 80,
          render: (h, p) => {
            return h('span', this.formatAmt(p.row, 'sellAmount1'))
          }
        },
        {
          title: '卖二量',
          key: 'sellAmount2',
          width: 80,
          render: (h, p) => {
            return h('span', this.formatAmt(p.row, 'sellAmount2'))
          }
        },
        {
          title: '卖三量',
          key: 'sellAmount3',
          width: 80,
          render: (h, p) => {
            return h('span', this.formatAmt(p.row, 'sellAmount3'))
          }
        },
        {
          title: '卖四量',
          key: 'sellAmount4',
          width: 80,
          render: (h, p) => {
            return h('span', this.formatAmt(p.row, 'sellAmount4'))
          }
        },
        {
          title: '卖五量',
          key: 'sellAmount5',
          width: 80,
          render: (h, p) => {
            return h('span', this.formatAmt(p.row, 'sellAmount5'))
          }
        },
        {
          title: '总量',
          key: 'businessAmount',
          width: 80,
          render: (h, p) => {
            return h('span', this.format(p.row, 'businessAmount'))
          }
        },
        {
          title: '现量',
          key: 'currentAmount',
          width: 80,
          render: (h, p) => {
            return h('span', this.format(p.row, 'currentAmount'))
          }
        },
        {
          title: '总额',
          key: 'businessBalance',
          width: 80,
          render: (h, p) => {
            return h('span', this.format(p.row, 'businessBalance'))
          }
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 60,
          render: (h, p) => {
            return this.listBtnRender(h, p)
          }
        }
      ],
      data: [],
      showTable: true,
      dataIndex: 0,
      goodsInfo: {
        code: '',
        name: '',
        unit: 1
      },
      operator: null
    }
  },
  created () {
    let top = 50
    this.$hMessage.config({
      top: top,
      infoTop: top,
      successTop: top,
      warningTop: top,
      errorTop: top,
    })
    if (window.isElectron) {
      Socket.connection({
        debug: false,
        success: frame => {
          this.connected = true
          Socket.subscribe('/topic/chart', message => {
            const msg = JSON.parse(message.body)
            this.$bus.$emit('ctlMainInit', msg)
            this.updatePageData(msg)
          })
        },
        failure: error => {
          console.log(error)
        }
      })
    }
    this.operator = Chart.IFrameSplitOperator
  },
  mounted () {
    // 获取自选商品
    this.optionalList = getOptionalData('goodsOptionalData')
    this.getGoodsList()
    // this.setHeight()
    this.importRouters()
    this.$nextTick(() => {
      if (window.isElectron) {
        let reload = this.$localStore.get('reload')
        if (reload) {
          this.$localStore.remove('reload')
          location.reload()
        } else {
          // 页面加载完成后，再显示
          this.$myIpcSend.ipcSender(this.$router, 'startshow')
        }
      }
    })
  },
  watch: {
    showTable: {
      handler (val) {
        if (val) {
          this.$nextTick(() => { this.setHeight() })
          window.onresize = () => {
            this.setHeight()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    // 列表操作按钮
    listBtnRender (h, p, type) {
      let _this = this
      let prodCode = p.row.prodCode
      let btnArr = []
      if (_this.optionalList.includes(prodCode)) {
        btnArr.push(h('Button', {
          props: {
            type: 'primary',
            size: 'small',
            icon: 'android-remove',
            title: '删除自选',
          },
          class: 'index-list-btn-icon',
          on: {
            'click': (event) => {
              event.stopPropagation()
              // 删除自选里面的，如果当前在自选列表，也要删除data的商品
              let index = _this.optionalList.findIndex(v => v === prodCode)
              _this.optionalList.splice(index, 1)
              if (_this.tabbarActive === 'optional') {
                _this.data.splice(index, 1)
              }
              setOptionalData('goodsOptionalData', _this.optionalList)
              this.messageTag('已从自选板块删除', 'info')
            }
          }
        }))
      } else {
        btnArr.push(h('Button', {
          props: {
            type: 'primary',
            size: 'small',
            icon: 'android-add',
            title: '添加自选',
          },
          class: 'index-list-btn-icon',
          on: {
            'click': () => {
              _this.optionalList.push(prodCode)
              setOptionalData('goodsOptionalData', _this.optionalList)
              _this.messageTag('已添加自选板块', 'success')
            }
          }
        }))
      }
      return h('div', btnArr)
    },
    // 信息提示
    messageTag (msg, type) {
      this.$hMessage[type](msg)
    },
    setHeight () {
      let content = document.querySelector('.quotation-content')
      if (content != null) {
        this.tableHeight = content.clientHeight - 28
      }
    },
    back () {
      this.optionalList = getOptionalData('goodsOptionalData')
      if (this.tabbarActive === 'optional') {
        this.data = this.data.filter(v => this.optionalList.includes(v.prodCode))
      }
      this.showTable = true
    },
    getGoodsList () {
      let mic = window.LOCAL_CONFIG.mic, param = {}
      if (mic) {
        param.marketType = mic
      }
      this.isLoading = true
      // 查询商品列表
      getGoodsList(param).then(r => {
        this.isLoading = false
        if (this.isError(r)) {
          return false
        }
        let list = r.data.items
        this.send('updateMarket', list)
        this.buildGoodsInfo(list || [])
      }).catch(e => {
        this.isLoading = false
        console.log(e)
      })
    },
    clickEvent (row, init) {
      lastTimer && clearTimeout(lastTimer)
      if (typeof lastClick === 'number' && lastClick === row[1]) {
        this.dbClickEvent(row[0])
        return
      }
      lastClick = row[1]
      lastTimer = setTimeout(() => {
        lastClick = null
      }, 300)
    },
    // table-行-双击事件-查看商品详情
    dbClickEvent (row) {
      let code = row['prodCode']
      this.dataIndex = row['_index']
      if (!code) {
        return this.$toast('error', '请先选择产品')
      }
      this.goodsInfo.code = code
      this.goodsInfo.name = row.prodName
      this.goodsInfo.unit = row.sharesPerHand
      this.prodCode = code + '.ET'
      this.tableCode = row.prodCode
      this.tableName = row.prodName
      this.showTable = false
      // // 修改刷新值
      this.sharesPerHand = row.sharesPerHand
      this.rowData = row
      this.$nextTick(() => {
        // 商品明细
        this.$refs.goodsDeal.getDealDetail(code)
        this.$refs.fiveGrade.initPageData(row)
        // 设置五档数据
        let fiveLevel = {
          bidGrp: row.bidGrp,
          offerGrp: row.offerGrp,
          sharesPerHand: row.sharesPerHand,
          prodCode: row.prodCode
        }
        this.$refs.fiveGrade.goodsFiveDeal(fiveLevel)
        this.$refs.cartView.updateDataStyle(row)
      })
    },
    // 构建商品信息
    buildGoodsInfo (items) {
      let data = []
      let ln = items.length
      let keys = this.getKeys()
      for (let i = 0; i < ln; i++) {
        let item = items[i]
        let obj = this.getItem(keys, item, {})
        this.setQuoteLevel(item, obj, i)
        // 默认第一条记录高亮显示
        if (i === this.dataIndex) {
          obj['_highlight'] = true
        }
        data.push(obj)
      }
      this.data = data
      this.allList = unit.cloneDeep(data)
    },
    getKeys () {
      const cols = this.columnsBuy
      return cols.filter(it => it.key && it.key !== 'action').map(it => it.key)
    },
    getItem (keys, item, obj) {
      Object.assign(obj, item)
      for (const k of keys) {
        obj[k] = item[k] || '-'
      }
      obj['tradeUnit'] = item['sharesPerHand']
      // 涨跌幅
      obj['risePrice'] = item['upPx'] || '-'
      obj['downPrice'] = item['downPx'] || '-'
      obj['incrRate'] = item['pxChangeRate'] || '-'
      return obj
    },
    // 构建五档行情
    setQuoteLevel (item, obj, idx) {
      let { bidGrp, offerGrp } = item
      // 处理买卖五档
      let buyLn = bidGrp.length
      for (let j = 0; j < buyLn; j++) {
        obj['buyPrice' + (j + 1)] = bidGrp[j].entrustPx || '-'
        obj['buyAmount' + (j + 1)] = bidGrp[j].totalEntrustAmount || '-'
      }
      let sellLn = offerGrp.length
      for (let j = 0; j < sellLn; j++) {
        obj['sellPrice' + (j + 1)] = offerGrp[j].entrustPx || '-'
        obj['sellAmount' + (j + 1)] = offerGrp[j].totalEntrustAmount || '-'
      }
    },
    // websocket-数据更新
    updatePageData (msg) {
      // 更新列表数据
      this.updateListData(msg)
      // 跟新5档数据
      this.$refs.fiveGrade && this.$refs.fiveGrade.fiveGradesDeal(msg)
      // 更新明细
      const { code } = this.goodsInfo
      if (code) {
        Object.keys(msg).forEach(key => {
          if (code === key) {
            this.$refs.goodsDeal && this.$refs.goodsDeal.getDealDetail(key)
          }
        })
      }
    },
    // websocket订阅数据，更新列表的数据
    updateListData (data) {
      let oldData = unit.cloneDeep(this.data)
      Object.keys(data).forEach(key => {
        // 查找原列表，更新的数据替换原来的数据
        let checkIndex = oldData.findIndex(v => v.prodCode === key)
        if (checkIndex > -1) {
          let newItem = data[key]
          let fiveLevel = unit.cloneDeep(newItem.fiveLevel)
          newItem.bidGrp = fiveLevel.bidGrp
          newItem.offerGrp = fiveLevel.offerGrp
          newItem.prodCode = newItem.symbol
          newItem.prodName = newItem.name

          let keys = this.getKeys()
          let obj = this.getItem(keys, newItem, {})
          this.setQuoteLevel(newItem, obj, -1)
          oldData[checkIndex] = Object.assign(oldData[checkIndex], obj)
          oldData[checkIndex].tradeUnit = oldData[checkIndex].sharesPerHand
          this.$set(this, 'data', JSON.parse(JSON.stringify(oldData)))
        }
      })
    },
    isError (r) {
      if (!r || !r.data) {
        this.$toast('error', '查询服务失败')
        return true
      }
      if (r.data.errorNo && r.data.errorNo !== '0') {
        this.$toast('error', r.data.errorInfo)
        return true
      }
      return false
    },
    /**
     *  底部nav切换（全部商品，自选商品）
     **/
    tabbarClick (value) {
      if (this.tabbarActive === value) return
      let list = []
      if (value === 'all') {
        list = unit.cloneDeep(this.allList)
      } else {
        this.optionalList.forEach(v => {
          let item = this.allList.find(item => item.prodCode === v)
          item && (list.push(item))
        })
      }
      this.tabbarActive = value
      this.data = list
    },
    send (key, value) {
      this.$bus.$emit(key, value)
    },
    importRouters (arr = ['uc', 'ctl']) {
      return new Promise((resolve) => {
        let list = []
        let getAll = []
        arr.forEach(item => {
          getAll.push(getChildData(item))
        })
        Promise.all(getAll).then(res => {
          if (res && res.length) {
            res.forEach(item => {
              if (typeof item !== 'undefined') {
                if (item && item.routes) {
                  list = [...list, ...item.routes]
                }
              }
            })
          }
          resolve(list)
        }).catch(error => {
          console.error(error)
        })
      })
    },
    format (row, key) {
      let val = row[key]
      return unit.priceFormat(val, key)
    },
    formatAmt (row, key) {
      let val = row[key]
      return unit.priceFormat(val, 'businessAmount')
    },
    getColor (val, prl) {
      let color = this.operator.FormatValueColor(val, prl)
      return color === 'PriceNull' ? 'preclosePx' : color
    }
  },
  beforeDestroy () {
    document.onkeydown = null
    // 取消更新链接
    Socket.disconnection()
  },
}
</script>
<style lang="scss" scoped>
.quotation-page {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 100vh;
  padding-top: 30px;
  overflow: hidden;
  -webkit-app-region: drag;
  color: #909399;
  .bgcolor {
    position: relative;
    height: 30px;
    background-image: linear-gradient(-44deg, #084dbb 0%, #07368a 100%);
    border-radius: 5px 5px 0 0;
    border-radius: 5px 5px 0px 0px;
    .headerstyle {
      position: absolute;
      top: 0px;
      left: 0px;
      -webkit-app-region: no-drag;
      span {
        font-size: 16px;
        color: #fff;
        line-height: 46px;
        padding-left: 16px;
      }
    }
    .reg-close {
      float: right;
      margin-right: 16px;
      margin-top: 16px;
      width: 10px;
      height: 10px;
      vertical-align: middle;
      -webkit-app-region: no-drag;
    }
    #iconreg {
      height: 30px;
      padding-left: 16px;
      -webkit-app-region: no-drag;
    }
  }
}
.h-topmenu {
  top: 0;
}
.quotation-content {
  height: calc(100vh - 30px);
  width: 100%;
  background: #121212;
  -webkit-app-region: no-drag;
  .h-table-wrapper {
    border: 0;
  }
}
/deep/.black {
  .h-table {
    background: #121212;
    th {
      color: #a5a5a5;
    }
    td {
      background: #121212;
      color: #a5a5a5;
    }
    /deep/.h-table-body-column-left {
      background-color: #121212;
    }
    .h-table-row-hover {
      td {
        background-color: #162a53;
      }
    }
    /deep/ .h-table-tbody {
      .h-table-row-hover td {
        background-color: #162a53;
      }
      line-height: 1;
      .h-table-row-checked td,
      .h-table-row-highlight td {
        background-color: #27498e;
      }
      .h-table-row-checked.h-table-row-hover td,
      .h-table-row-highlight.h-table-row-hover td {
        background-color: #27498e;
      }
      tr.h-table-row td span {
        cursor: default;
        line-height: 1.5;
        -webkit-user-select: none;
      }
      tr.h-table-row td div {
        cursor: default;
        -webkit-user-select: none;
      }
    }
  }
}
.trend-view {
  position: relative;
  height: 100%;
  display: flex;
  .back-btn {
    position: absolute;
    left: 30px;
    top: 4px;
    padding: 0 3px;
    cursor: pointer;
    border-radius: 4px;
    z-index: 100;
    &:active {
      border: 1px solid #666666;
    }
  }
  .left-view {
    flex: 1;
  }
  .right-view {
    width: 250px;
    border-left: 1px solid #333;
    font-size: 16px;
    text-align: left;
    overflow: hidden;
  }
}
.right-part /deep/ .el-tabs__header {
  background-color: #0a0b11;
  border-bottom: 1px solid #1e1e1e;
  margin: 0;
}
.right-view {
  /deep/.el-tabs__nav-wrap {
    z-index: 0;
  }
  /deep/ .el-tabs__item {
    font-size: 12px;
  }
  .goods-style {
    padding: 5px 10px;
    text-align: center;
    font-size: 16px;
    p {
      display: inline-block;
      text-align: center;
    }
  }
}
.lightblue /deep/.h-table-fixed-right .h-table-hidden .h-table-cell{padding-left:10px;padding-right:10px}
</style>
